const msnryImages = document.querySelectorAll('.grid--collection .grid-product');
// const msnryImages = Shopify.collectionMasonryImages

$(document).ready(function(){
  if (window.matchMedia("(min-width: 769px)").matches) {
    
    const msnry = new Masonry( '.grid--collection', { itemSelector: '.grid__item' });
    
    const loadCollectionImages = new Promise(function(resolve, reject) {
      Shopify.collectionMasonryImages.forEach(({ index, src, thumb, title }) => {

        if (msnryImages[index-1]) {
          msnryImages[index-1].insertAdjacentHTML("beforebegin", `
			<div class="grid__item grid-product one-half amber" data-aos="row-of-4">
				<div class="grid-product__content" style="background-image: url('${thumb}');" data-index="${index}" title="image">
					<img style="width: 100%" />
				</div>
			</div>`);
        
          const newTile = document.querySelector(`[data-index="${index}"]`);
          const newImage = newTile.querySelector(`img`);
        
          newTile.classList.add('loading');
       
          newImage.src = src;
          newImage.onload = function () {
          newTile.classList.add('loaded');
          newTile.classList.remove('loading');
          };
        };
        
      });
      resolve('Collection images loaded.');
    });
    
    loadCollectionImages.then(result => {
		msnry.reloadItems();
      	msnry.layout();
    });
  }

$('.variant-input').click(function() {
  $(this).parent().find('.variant-input').removeClass('active')
  $(this).addClass('active') 
});

})

// $('h4:contains("Filter by")').remove();